module.exports = __webpack_public_path__ + "static/img/g301.2a53dfe8.png";